import { useState, useEffect } from "react";
import { Box, Typography, IconButton, TextField } from "@mui/material";
import ArrowUpwardOutlinedIcon from "@mui/icons-material/ArrowUpwardOutlined";
import ArrowDownwardOutlinedIcon from "@mui/icons-material/ArrowDownwardOutlined";

interface HeaderProps {
  field: string;
  sortField: string;
  headerName: string | undefined;
  showFilter: boolean;
  width?: number;
  type?: string;
  onFilterSubmit: (value: any) => void;
  isSortable?: boolean;
}

export default function TableHeaderTextField({
  field,
  sortField,
  headerName,
  showFilter,
  width,
  type,
  onFilterSubmit,
  isSortable = true,
}: HeaderProps) {
  const [text, setText] = useState("");
  const [sort, setSort] = useState("asc");
  const [debouncedInputValue, setDebouncedInputValue] = useState("");
  const titleWidth = width ? width - 62 : width;

  useEffect(() => {
    const delayInputTimeoutId = setTimeout(() => {
      setDebouncedInputValue(text);
    }, 500);
    return () => clearTimeout(delayInputTimeoutId);
  }, [text]);

  useEffect(() => {
    onFilterSubmit({ [field]: debouncedInputValue });
  }, [debouncedInputValue]); // eslint-disable-line

  const toggleSorting = () => {
    onFilterSubmit({ sortColumn: sortField, sortOrder: sort });
    setSort(sort === "asc" ? "desc" : "asc");
  };

  return (
    <Box sx={{ width }}>
      <Box className="header" sx={{ display: "flex", alignItems: "center" }}>
        <Typography sx={{ fontWeight: "bold", width: titleWidth }} noWrap>
          {headerName}
        </Typography>
        {isSortable && (
          <IconButton aria-label="sort" onClick={toggleSorting}>
            {sort === "asc" ? (
              <ArrowUpwardOutlinedIcon
                className="ArrowUpwardIcon"
                sx={{ fontSize: 17, display: "none" }}
              />
            ) : (
              <ArrowDownwardOutlinedIcon
                className="ArrowUpwardIcon"
                sx={{ fontSize: 17, display: "none" }}
              />
            )}
          </IconButton>
        )}
      </Box>
      <TextField
        variant="outlined"
        placeholder={headerName}
        fullWidth
        type={type || ""}
        size="small"
        sx={{
          mt: 1,
          display: showFilter ? "block" : "none",
          "& input[type=number]": {
            "-moz-appearance": "textfield",
          },
          "& input[type=number]::-webkit-outer-spin-button": {
            "-webkit-appearance": "none",
            margin: 0,
          },
          "& input[type=number]::-webkit-inner-spin-button": {
            "-webkit-appearance": "none",
            margin: 0,
          },
        }}
        className="filterTextField"
        value={text}
        onChange={(e) => setText(e.target.value)}
      />
    </Box>
  );
}
